import gmx_zMixins         from '../../../../includes/Jmixins/zMixins'

// Library
// import gmx_d3_Library              from '../../../../../includes/D3_Libraries/zMixins'

// Locally declared common Data-Props & SVG Drawing Support

import lmx_LocalValues          from './set_LocalValues'
import lmx_localData            from '../primitives/localData'
import lmx_Watching             from './Watching'

import lmx_Events               from './Events'
import lmx_Forms                from './draw_Forms'
import lmx_Chart                from './draw_Chart'
import lmx_Gauge                from './draw_Gauge'


export default {
  mixins: [
    gmx_zMixins, 
    lmx_localData,
    
    // Local Mixins
    
    lmx_Watching,
    lmx_Events,
    
    lmx_LocalValues,
    lmx_Forms,
    lmx_Chart,
    lmx_Gauge,
  ],
}
